import React from 'react'
import injectSheet from 'react-jss'
import styles from './toggle-switch.styles'
import classNames from 'classnames'

const ToggleSwitch = ({ classes, className, disabled, ...props }) => (
  <label
    className={classNames(
      classes.container,
      { [classes.disabled]: disabled },
      className
    )}>
    <input disabled={disabled} type="checkbox" {...props} />
    <div className={classes.slider} />
  </label>
)

export default injectSheet(styles)(ToggleSwitch)
